<template>
	<sf-modal-layout size="l" :title="comCdTitle" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<com-cd-popup-search ref="ComCdPopupSearch" :scrId="scrId"></com-cd-popup-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<com-cd-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId"></com-cd-popup-table>
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/ComCdPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import ComCdPopupSearch from './Content/Search/ComCdPopupSearch.vue';
import ComCdPopupTable from './Content/Table/ComCdPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { ComCdPopupSearch, ComCdPopupTable },
	data() {
		return {
			show: false,
			title: ''
		};
	},
	created() {
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.setStateInit_();
			this.show = true;

			this.setState_({ key: 'comCdTitle', value: param.title });
			if (param.causPartNo !== null) {
				this.setSearchParam_({ key: 'causPartNo', value: param.causPartNo });
			}
			this.setSearchParam_({ key: 'commCdType', value: param.commCdType });
			this.setSearchParam_({ key: 'commCd', value: param.commCd });
			//console.log('param', param);

			if (this.$refs.ComCdPopupSearch != undefined) {
				this.$refs.ComCdPopupSearch.searchList();
			}
		},

		close() {
			this.show = false;
		},
		sendData(sendParam) {
			this.$emit('SendData', sendParam);
			this.close();
		},
		reload() {
			this.$refs.ComCdPopupSearch.searchList();
		}
	}
};
</script>

<style></style>
